import { mkEntityIdCodec } from '@code-expert/mongo-ts/identity';
import type { eq } from '@code-expert/prelude';
import { iots, string } from '@code-expert/prelude';
import { TaskId, UserId } from '/imports/domain';
import { BlankId } from '/imports/modules/Quizzes/clozetext/domain/Blank';
import { QuestionId } from '/imports/modules/Quizzes/domain/Question';
import type { QuizId } from '/imports/modules/Quizzes/domain/Quiz';
import { QuizSnapshotId } from './QuizSnapshot';

//--------------------------------------------------------------------------------------------------

export const QuizAttemptIdBrand = Symbol('QuizAttemptId');
export const QuizAttemptId = mkEntityIdCodec(QuizAttemptIdBrand);
export type QuizAttemptId = iots.TypeOf<typeof QuizAttemptId>;
export const quizAttemptIdEq: eq.Eq<QuizId> = string.Eq;

//--------------------------------------------------------------------------------------------------

export const BlankValuesC = iots.record(QuestionId, iots.record(BlankId, iots.string));
export type BlankValues = iots.TypeOf<typeof BlankValuesC>;

export const QuizAttempt = iots.struct(
  {
    _id: QuizAttemptId,
    studentId: UserId,
    taskId: TaskId,
    snapshotId: QuizSnapshotId,
  },
  {
    blankValues: BlankValuesC,
  },
);

export type QuizAttempt = iots.TypeOf<typeof QuizAttempt>;
